import React from "react";
import { matchPath, useLocation } from "react-router-dom";
import Header from "./Header";
import DiscordHelp from "./DiscordHelp";
import { ROUTES } from "../router/routes";
import "./MainLayout.css";

/**
 * MainLayout - Main application layout wrapper
 * Includes header and main content area
 * @param {Object} props
 * @param {React.ReactNode} props.children - Page content
 */
const MainLayout = ({ children }) => {
  const location = useLocation();
  const hideDiscordHelp =
    Boolean(matchPath(ROUTES.NEWS_EDITOR, location.pathname)) ||
    Boolean(matchPath(ROUTES.NEWS_EDIT, location.pathname));

  return (
    <div className="main-layout">
      <a className="main-layout__skip-link" href="#main-content">
        Skip to main content
      </a>
      <Header />
      <main className="main-layout__content" id="main-content">
        {children}
      </main>
      {hideDiscordHelp ? null : <DiscordHelp />}
    </div>
  );
};

export default MainLayout;
